import controller from './new-facility-modal-controller';
import template from './new-facility-modal.html';

const NewFacilityModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default NewFacilityModalComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/new-facility-modal/new-facility-modal-component.js